module.exports = __webpack_public_path__ + "img/poster.dd4b53ce.webp";